// 百度埋点
function buriedPoint () {
  setTimeout(() => {
    document.getElementById('baidu_tj') &&
      document.getElementById('baidu_tj').remove()
    var _hmt = _hmt || []
    ;(function() {
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?3e83d83770de30dae531add3fea84937'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
    ;(function() {
      var hm = document.createElement('script')
      hm.src = 'https://img.iglobalwin.com/track/track.js'
      hm.setAttribute('siteid', '1311408964436492288')
      hm.setAttribute('url', 'https://api.skymonitor.skytech.cn/')
      hm.setAttribute('id', 'trackjs')
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
  }, 0)

  function skyAddEvent(eventName, func) {
    if (window.addEventListener) {
      window.addEventListener(eventName, func, false)
    } else if (window.attachEvent) {
      window.attachEvent(`on${eventName}`, func)
    } else if (window.onload) {
      window[`on${eventName}`] = func
    }
  }

  function convertParamsToUrlQuery(params) {
    var paramStr = Object.keys(params)
      .filter(function(key) {
        return params[key] != undefined
      })
      .map(function(key) {
        return `${key}=${params[key]}`
      })
      .join('&')
    if (paramStr.length) {
      paramStr = `?${paramStr}`
    }
    return paramStr
  }

  function sendlog(config, params) {
    var imgNode = document.createElement('img')
    var paramStr = convertParamsToUrlQuery(params)
    imgNode.src = `${config.accpetUrl}/${config.id}${paramStr}`
  }

  var smc = {
    id: '1311408964436492288',
    accpetUrl: 'https://api.skymonitor.skytech.cn/log/collect',
  }

  var param = { previousPath: window.document.referrer }
  skyAddEvent('load', function() {
    sendlog(smc, param)
  })
}

export default buriedPoint
